import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Work from './pages/Work';
import CaseStudyDetail from './pages/CaseStudyDetail';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import MarTech from './pages/MarTech';
import Insights from './pages/Insights';
import InsightDetail from './pages/InsightDetail';
import Press from './pages/Press';
import ClientPortal from './pages/ClientPortal';
import Dashboard from './pages/Dashboard';
import FeedbackAnalytics from './pages/FeedbackAnalytics';
import SubmitCaseStudy from './pages/SubmitCaseStudy';
import FractionalCMO from './pages/FractionalCMO';
import WorkWithMe from './pages/WorkWithMe';
import CallWidget from './components/ui/CallWidget';
import ConnectingDots from './components/ui/ConnectingDots';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ConditionalCallWidget = () => {
  return <CallWidget />;
};

function App() {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen font-sans text-slate-900 dark:text-white bg-white dark:bg-brand-dark transition-colors duration-300 relative overflow-hidden">
        <ConnectingDots />
        <Navbar isDark={isDark} setIsDark={setIsDark} />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/work" element={<Work />} />
            <Route path="/work/:id" element={<CaseStudyDetail />} />
            <Route path="/toolbox" element={<MarTech />} />
            <Route path="/martech-toolbox" element={<MarTech />} />
            <Route path="/case-studies" element={<Work />} />
            <Route path="/case-studies/:id" element={<CaseStudyDetail />} />
            <Route path="/the-tool-trap" element={<Insights />} />
            <Route path="/the-tool-trap/:slug" element={<InsightDetail />} />
            <Route path="/resources/downloads" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/martech" element={<MarTech />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/press" element={<Press />} />
            <Route path="/portal" element={<ClientPortal />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/strategy-hub" element={<Dashboard />} />
            <Route path="/feedback-analytics" element={<FeedbackAnalytics />} />
            <Route path="/submit-case-study" element={<SubmitCaseStudy />} />
            <Route path="/fractional-cmo" element={<FractionalCMO />} />
            <Route path="/work-with-me" element={<WorkWithMe />} />
          </Routes>
        </main>
        <ConditionalCallWidget />
        <Footer />
      </div>
    </Router>
  );
}

export default App;